/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ numberOfRecords: NonNullable<unknown> }} Bold_Dusty_Dove_YawnInputs */

const en_bold_dusty_dove_yawn = /** @type {(inputs: Bold_Dusty_Dove_YawnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting for confirmation for import of ${i?.numberOfRecords} records`)
};

const de_bold_dusty_dove_yawn = /** @type {(inputs: Bold_Dusty_Dove_YawnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Warte auf Bestätigung für Import von ${i?.numberOfRecords} Datensätzen`)
};

/**
* | output |
* | --- |
* | "Waiting for confirmation for import of {numberOfRecords} records" |
*
* @param {Bold_Dusty_Dove_YawnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_dusty_dove_yawn = /** @type {((inputs: Bold_Dusty_Dove_YawnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Dusty_Dove_YawnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_dusty_dove_yawn(inputs)
	return de_bold_dusty_dove_yawn(inputs)
});